// extracted by mini-css-extract-plugin
module.exports = {"textSliderSection":"TextSlider_textSliderSection__3KZt9","textSlider":"TextSlider_textSlider__g2ZcH"};